import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingRulesEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingRulesEntity
